import { AppBar, Box, Toolbar } from "@mui/material";
import Logotype from "../topbar/Logotype";

export default function LogoutFooter() {

    return (
        <AppBar
            position="fixed"
            color="default"
            elevation={0}
            sx={{
                top: 'auto',
                bottom: 0,
                backgroundColor: '#ffffff',
                borderTop: '1.5px solid #009CDF',
            }}
        >
            <Toolbar variant="dense" sx={{ pl: 2, pr: 2 }} disableGutters>
                <Box sx={{ flexGrow: 1 }}>
                    <Logotype />
                </Box>
            </Toolbar>
        </AppBar>
    );
}